var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import './checkbox.styles.scss';
var Checkbox = function (props) {
    var _a = React.useState(props.checked || false), checked = _a[0], setChecked = _a[1];
    React.useEffect(function () {
        setChecked(props.checked || false);
    }, [props.checked]);
    var onChange = function (event) {
        var onChange = props.onChange, disabled = props.disabled;
        var checked = event.target.checked;
        if (disabled)
            return;
        setChecked(checked);
        onChange && onChange(checked);
    };
    var labelPosition = props.labelPosition ? props.labelPosition : 'right';
    return (React.createElement("label", { className: "checkbox-container" },
        props.label && labelPosition === 'left' && (React.createElement("span", { className: "checkbox-label" }, props.label)),
        React.createElement("label", { className: (props.shape || 'default') + "-checkbox " + (props.disabled ? 'disabled' : '') },
            React.createElement("input", __assign({ type: "checkbox" }, props, { checked: checked, onChange: onChange })),
            React.createElement("span", { className: "checkmark " + (props.disabled ? 'disabled' : '') })),
        props.label && labelPosition === 'right' && (React.createElement("span", { className: "checkbox-label" }, props.label))));
};
export default Checkbox;
//# sourceMappingURL=checkbox.js.map